import React from 'react'
import '../Styles/NavBar.css'

const NavBar = () => {
    return (
        <div className="nav">
            <div className="navbar p-3">
                <h4>Where in the World<i class="fas fa-globe-americas"></i></h4>
           </div>

        </div>

    )
}

export default NavBar
